<div [innerHtml]="jsonLDString"></div>
<section class="plan-and-features-section">
    <div class="container-flex-fluid">
        <!-- <app-plans-layout-b *ngIf="!!planB" (addPlanToCart)="addToCart($event)"></app-plans-layout-b> -->
        <app-plans-layout-a (addPlanToCart)="addToCart($event)"></app-plans-layout-a>
    </div>
    <section class="faqs-section page-section">
            <h1 class="faqs-title">FAQs</h1>
            <h4 class="faqs-sub-title">Got question? We got answers!</h4>
            <div class="faqs-margins">
                    <div class="questions">
                        <div class="question" *ngFor="let qst of firstThreeQuestions">
                            <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
                                [class.active]="qst?.fields?.questionId == questionId"
                                [isActive]="qst?.fields?.questionId == questionId"
                                (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                            </app-question-answer>
                        </div>
                        <div *ngIf="!!showMore">
                            <div *ngFor="let qst of restQuestions">
                                <app-question-answer question="{{qst?.fields?.questionText}}"
                                    [id]="qst?.fields?.questionId"
                                    [class.active]="qst?.fields?.questionId == questionId"
                                    [isActive]="qst?.fields?.questionId == questionId"
                                    (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                    <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                                </app-question-answer>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="more-less-faqs-part">
                <div class="more-less" (click)="showMore = !showMore">
                    <a>{{ !showMore ? 'More FAQs' : 'Less FAQs' }}</a>
                    <img src="/assets/icon/circle-down-arrow-icon.svg" alt="Circle Arrow Icon"
                        [class.rotate]="!!showMore" width="20" height="20">
                </div>
            </div>
    </section>
</section>